export default function StorageWheel({ usedGb = 0, totalGb = 200, size = 220, testId = 'storage-wheel' }) {
    const pct = Math.max(0, Math.min(1, totalGb > 0 ? usedGb / totalGb : 0));
    const stroke = 14;
    const r = (size - stroke) / 2;
    const c = 2 * Math.PI * r;
    const offset = c * (1 - pct);

    return (
        <div className="relative inline-flex items-center justify-center" data-testid={testId}>
            <svg width={size} height={size} className="-rotate-90">
                <circle cx={size / 2} cy={size / 2} r={r} stroke="hsl(var(--muted))" strokeWidth={stroke} fill="transparent" />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={r}
                    stroke="#FF6B35"
                    strokeWidth={stroke}
                    strokeLinecap="round"
                    fill="transparent"
                    strokeDasharray={c}
                    strokeDashoffset={offset}
                    style={{ transition: 'stroke-dashoffset 0.8s cubic-bezier(0.4,0,0.2,1)' }}
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="font-heading text-3xl font-medium">{usedGb.toFixed(1)}</span>
                <span className="text-xs uppercase tracking-[0.2em] text-muted-foreground mt-1">of {totalGb} GB used</span>
                <span className="text-[10px] uppercase tracking-[0.2em] text-[#FF6B35] mt-2">{(pct * 100).toFixed(1)}%</span>
            </div>
        </div>
    );
}
